'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UICardSection from 'UIComponents/card/UICardSection';
import UIFlex from 'UIComponents/layout/UIFlex';
import Branding from 'MeetingsBase/models/Branding';
import { getTextColor } from 'MeetingsBase/utils/color';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const ColoredCardSection = styled.div.withConfig({
  displayName: "ColoredCard__ColoredCardSection",
  componentId: "icdftg-0"
})(["display:flex;flex-direction:column;justify-content:center;"]);
export default class ColoredCard extends Component {
  constructor(...args) {
    super(...args);
    this.getPrimaryColorToUse = () => {
      const {
        branding: {
          primaryColor
        }
      } = this.props;
      return primaryColor;
    };
    this.getTextColorToUse = () => {
      const {
        branding: {
          primaryColor
        }
      } = this.props;
      return getTextColor(primaryColor);
    };
    this.getStyle = () => {
      const primaryColorToUse = this.getPrimaryColorToUse();
      const textColorToUse = this.getTextColorToUse();
      return {
        backgroundColor: primaryColorToUse,
        backgroundImage: 'none',
        color: textColorToUse
      };
    };
  }
  render() {
    const {
      className,
      cardSectionClassName,
      children
    } = this.props;
    return /*#__PURE__*/_jsx(UICardWrapper, {
      className: className,
      style: this.getStyle(),
      children: /*#__PURE__*/_jsx(UICardSection, {
        className: cardSectionClassName,
        children: /*#__PURE__*/_jsx(ColoredCardSection, {
          children: /*#__PURE__*/_jsx(UIFlex, {
            direction: "column",
            children: children
          })
        })
      })
    });
  }
}
ColoredCard.propTypes = {
  className: PropTypes.string,
  cardSectionClassName: PropTypes.string,
  children: PropTypes.node.isRequired,
  branding: PropTypes.instanceOf(Branding).isRequired
};